import { OnboardingRemovalStrategy } from '../../views/Settings/OnboardingRemovalStrategy';

export function OnboardingRemovalStrategyPage() {
  return <OnboardingRemovalStrategy />;
}
